import type { DashboardAlertsTranslations } from "../interfaces/dashboardAlerts";

export const dashboardAlertsTranslations: DashboardAlertsTranslations = {
  alert_payin_title: "A payment of {{amount}} arrived",
  alert_payin_from: "From {{name}}",
  alert_payin_collection_via: "Collection via {{rail}}",
  alert_payout_paid_title: "Your transfer of {{amount}} arrived",
  alert_payout_failed_title: "Your transfer of {{amount}} did not go through",
  alert_payout_failed_body: "Open the details to see what happened.",
  alert_payout_via: "Via {{rail}}",
  alert_batch_completed_title: "Your payout batch finished",
  alert_batch_completed_with_errors_title: "Your payout batch finished with errors",
  alert_batch_failed_title: "Your payout batch could not be completed",
  alert_batch_paid: "{{count}} paid",
  alert_batch_failed_rows: "{{count}} failed",
  alert_batch_paid_one: "1 paid",
  alert_batch_failed_rows_one: "1 failed",
  alert_card_approved_title: "Purchase of {{amount}} approved",
  alert_card_declined_title: "Purchase of {{amount}} declined",
  alert_card_refund_title: "Refund of {{amount}} to your card",
  alert_card_reversal_title: "A purchase of {{amount}} was reversed",
  alert_card_detail: "Card •••• {{last4}}",
  alert_card_approved_no_amount: "Purchase approved on your card",
  alert_card_declined_no_amount: "Purchase declined on your card",
  alert_card_refund_no_amount: "Refund to your card",
  alert_card_reversal_no_amount: "A purchase was reversed",
  alert_view_transaction: "View transaction",
  alert_view_batch: "View batch",
  summary_payins_breb_key: "{{count}} payments arrived on your keys",
  summary_payins_collections: "{{count}} of your collections were paid",
  summary_payouts_paid: "{{count}} of your transfers arrived",
  summary_payouts_failed: "{{count}} transfers did not go through",
  summary_payout_batches_done: "{{count}} payout batches finished",
  summary_cards_purchase_approved: "{{count}} purchases approved on your cards",
  summary_cards_purchase_declined: "{{count}} purchases declined on your cards",
  summary_cards_refund: "{{count}} refunds to your cards",
  summary_total: "{{amount}} in total",
  summary_view: "View all",
  section_eyebrow: "Notifications",
  section_title: "Dashboard alerts",
  section_sub:
    "A message in the corner of the screen when something happens, while the dashboard is open. When several arrive in a row, they are grouped into one.",
  section_count: "{{on}} of {{total}} on",
  group_payins: "Incoming payments",
  group_payouts: "Transfers",
  group_payout_batches: "Batch payouts",
  group_cards: "Cards",
  type_payins_breb_key: "Payments to your Bre-B keys",
  type_payins_breb_key_hint:
    "When someone pays you with your any-amount QR or by typing your key. With the QR open, the notice shows inside the QR.",
  type_payins_collections: "Paid collections",
  type_payins_collections_hint:
    "When a collection you created is paid: QR with an amount, PSE, Nequi, Botón Bancolombia, PIX or SPEI, or a transfer to your account.",
  type_payouts_paid: "Transfers that arrived",
  type_payouts_paid_hint: "When the destination confirms a transfer you sent.",
  type_payouts_failed: "Transfers that did not go through",
  type_payouts_failed_hint: "When a transfer is rejected or reversed.",
  type_payout_batches_done: "Finished batches",
  type_payout_batches_done_hint: "When a payout batch finishes running, with or without errors.",
  type_cards_purchase_approved: "Approved purchases",
  type_cards_purchase_approved_hint: "Every approved purchase with your organization's cards.",
  type_cards_purchase_declined: "Declined purchases",
  type_cards_purchase_declined_hint: "When the merchant or the issuer declines a purchase.",
  type_cards_refund: "Refunds and reversals",
  type_cards_refund_hint: "When a merchant returns money to a card or a purchase is reversed.",
  browser_note: "Saved in this browser: on another computer or phone you can choose differently.",
  whatsapp_note: "Also on WhatsApp, even when the dashboard is closed?",
  whatsapp_payments_link: "Payment alerts",
  whatsapp_cards_link: "Card alerts",
  sound_label: "Alert sound",
  sound_hint: "Turn it off to silence them all without changing what you chose for each one.",
  mode_sound: "With sound",
  mode_silent: "Silent",
  mode_off: "Off",
  mode_group_aria: "How we alert you about {{label}}",
  sound_listen: "Listen",
  sound_listen_problem: "If it fails",
  sound_desc_payins: "A small bell going up.",
  sound_desc_payouts: "Two wooden notes: up when it arrived, down when it did not.",
  sound_desc_payout_batches: "Tick, tick, tick and a bell; it goes down if something failed.",
  sound_desc_cards: "A card terminal's beep-beep; one sinking beep when it is declined.",
  intro_title: "This is how we'll tell you",
  intro_body:
    "When something happens with your money, a message shows at the top of the screen while the dashboard is open. Each section sounds different, so you know what it is without looking.",
  intro_footer: "Choose which ones sound, which only show and which to turn off.",
  intro_settings: "Set up alerts",
  intro_dismiss: "Got it",
  intro_close: "Close",
};
